const ordersDefaultState = {};

export default (state = ordersDefaultState, action) => {
  let tempState = [...state];

  switch (action.type) {
    default:
      return tempState;

    case "SET_ORDERS":
      return action.orders;

    // TODO: create an explicit id property in each order object
    case "CHANGE_ORDER_STATUS":
      tempState.forEach(function(order, i){
        if(order._id === action.id){
          tempState[i].status = action.status;
          return;
        }
      });
      return tempState;

    case "ADD_ORDER":
      tempState.push(action.payload);
      return tempState;

    case "DELETE_ORDER":
      tempState.forEach(function(order, i){
        if(order._id === action.id){
          tempState.splice(i, 1);
          return;
        }
      });
      return tempState;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/orders.js